import {
  ChangeDetectionStrategy,
  Component,
  inject,
  output,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {
  ButtonComponent,
  ButtonTextDirective,
} from '../../button/button.component';

// TODO: Rename to error "modal" to be consistent w/ other modals.
@Component({
  selector: 'app-error-modal',
  templateUrl: './error-dialog.component.html',
  imports: [
    MatIconModule,
    MatDialogModule,
    ButtonComponent,
    ButtonTextDirective,
  ],
  styleUrls: ['../modal.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorDialogComponent {
  #dialogRef = inject(MatDialogRef);
  message = inject(MAT_DIALOG_DATA);

  confirmed = output<void>();

  get formattedMessage() {
    if (Array.isArray(this.message) && this.message.length > 1) {
      let htmlString =
        '<p class="mb-2">Operation failed due to the following errors:</p>';
      htmlString += '<ul class="list-decimal list-inside space-y-1">';
      for (const m of this.message) {
        htmlString += '<li>';
        htmlString += m;
        htmlString += '</li>';
      }
      htmlString += '</ul>';
      return htmlString;
    }

    return `${this.message}`;
  }

  closeDialog(): void {
    this.#dialogRef.close();
  }

  confirm(): void {
    this.confirmed.emit();
    this.closeDialog();
  }
}

export function openErrorModal(dialog: MatDialog, data: string[] | string, disableClose: boolean = false) {
  return dialog.open(ErrorDialogComponent, {
    id: 'error-modal',
    data,
    disableClose,
  });
}
